import Vue from 'vue'

export const state = () => ({
  loggedIn: false,
  user: {},
  token: null
})

export const actions = {
  registerUser(context, form) {
    return this.$axios.post('/user/create', form)
  },
  registerPassword(context, form) {
    return this.$axios.post('/user/confirm-sms-code', form)
  },
  resetPassword({ state }, form) {
    this.$axios.setToken(state.token, 'Bearer', ['post'])

    return this.$axios.post('/user/reset-password', form)
  },
  resetEmail(context, email) {
    return this.$axios.post('/user/request-reset-password', {
      email
    })
  },
  loginUser(context, form) {
    return this.$axios.post('/user/login', form)
  },
  checkToken(context, token) {
    this.$axios.setToken(token, 'Bearer', ['get'])

    return this.$axios.get('/user')
  },
  vote({ state }, id) {
    this.$axios.setToken(state.token, 'Bearer', ['post'])

    return this.$axios.post('/participant-page/like', { id })
  },
  unVote({ state }, id) {
    this.$axios.setToken(state.token, 'Bearer', ['post'])

    return this.$axios.post('/participant-page/dislike', {
      id
    })
  }
}

export const mutations = {
  SET_USER(state, user) {
    Vue.set(state, 'user', user)
  },
  REMOVE_TOKEN(state) {
    Vue.set(state, 'token', null)
  },
  SET_LOGIN(state, type) {
    Vue.set(state, 'loggedIn', type)
  },
  SET_TOKEN(state, token) {
    Vue.set(state, 'token', token)
  }
}

export const getters = {
  user: state => state.user,
  loggedIn: state => state.loggedIn,
  token: state => state.token
}



// WEBPACK FOOTER //
// ./store/auth.js